"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const qs_1 = __importDefault(require("qs"));
const API = {
    getOverviewStats: '/api/tracking/event/stats/published/getOverviewStats',
    getDetailStats: '/api/tracking/event/stats/published/getDetailStats',
};
class Upload {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getOverviewStats(serviceId, month, year) {
        const query = {
            serviceId,
            month,
            year,
        };
        const url = `${API.getOverviewStats}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async getDetailStats(serviceId, startDate, endDate, groupBy) {
        const query = {
            serviceId,
            startDate,
            endDate,
            groupBy,
        };
        const url = `${API.getDetailStats}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
}
exports.default = Upload;
